/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_FetchInputs */

const en_jobs_fetch = /** @type {(inputs: Jobs_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetch`)
};

const de_jobs_fetch = /** @type {(inputs: Jobs_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrufen`)
};

const fr_jobs_fetch = /** @type {(inputs: Jobs_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récupérer`)
};

const es_jobs_fetch = /** @type {(inputs: Jobs_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtener`)
};

const it_jobs_fetch = /** @type {(inputs: Jobs_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recupera`)
};

const nl_jobs_fetch = /** @type {(inputs: Jobs_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ophalen`)
};

const pl_jobs_fetch = /** @type {(inputs: Jobs_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobierz`)
};

const fi_jobs_fetch = /** @type {(inputs: Jobs_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae`)
};

const da_jobs_fetch = /** @type {(inputs: Jobs_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hent`)
};

const sv_jobs_fetch = /** @type {(inputs: Jobs_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hämta`)
};

/**
* | output |
* | --- |
* | "Fetch" |
*
* @param {Jobs_FetchInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_fetch = /** @type {((inputs?: Jobs_FetchInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_FetchInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_fetch(inputs)
	if (locale === "fr") return fr_jobs_fetch(inputs)
	if (locale === "es") return es_jobs_fetch(inputs)
	if (locale === "it") return it_jobs_fetch(inputs)
	if (locale === "nl") return nl_jobs_fetch(inputs)
	if (locale === "pl") return pl_jobs_fetch(inputs)
	if (locale === "fi") return fi_jobs_fetch(inputs)
	if (locale === "da") return da_jobs_fetch(inputs)
	if (locale === "sv") return sv_jobs_fetch(inputs)
	return en_jobs_fetch(inputs)
});